import { Container } from "./styles";
import ProfilePic from "../../assets/Vijay.jpeg";
import android from "../../assets/android.svg"
import java from "../../assets/java.svg"
import kotlin from "../../assets/kotlin.svg"
import jsIcon from "../../assets/js-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            Hi there! I'm Vijay, an enthusiastic Mobile App Developer Skilled in Android and React-Native.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <p>
            I build many types of mobile applications which includes real time apps,web based apps,custom app development.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={400}>
          <div className="education">
            <h3>Education:</h3>
            <h4> Master of Computer Applications (MCA)</h4>
            <p> Atmiya institute,Rajkot | April 2014 - April 2016</p>
            <p>8.45 CGPA</p>
            <br/>
            <h4>Bechlor of Computer Applications (BCA)</h4>
            <p> Gujarat University | March 2011 - April 2014</p>
            <p>7.45 CGPA</p>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={550}>
          <div className="experience">
            <h3>Experience:</h3>
            <h4>React Native Developer</h4>
            <p>DotPitch Technologies | Dec 2022 - Nov 2024</p>
            <p>Rajkot,Gujarat,India</p>
            <br/>
            <h4>React Native Developer</h4>
            <p>Angel Infotech | March 2022 - August 2022</p>
            <p>Rajkot,Gujarat,India</p>
            <br/>
            <h4>Android Developer</h4>
            <p>VG Infotech | Dec 2020 - February 2022</p>
            <p>Rajkot,Gujarat,India</p>
            <br/>
            <h4>Android Developer</h4>
            <p>Adm Systems | Sept 2018 - February 2019</p>
            <p>Rajkot,Gujarat,India</p>
            <br/>
            <h4>Android Developer</h4>
            <p>Ipath Solutions| June 2017 -  June 2018</p>
            <p>Rajkot,Gujarat,India</p>
            <br/>
            <h4>Android Developer</h4>
            <p>Sanatan Technovation| June 2016 -  May 2017</p>
            <p>Rajkot,Gujarat,India</p>     
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        <div className="hard-skills">
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.10 * 1000}>
              <img src={android} alt="Android" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.11 * 1000}>
              <img src={kotlin} alt="Kotlin" />
            </ScrollAnimation>
          </div>
           <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.11 * 1000}>
              <img src={java} alt="kotlin" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React-Native" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.21 * 1000}>
          <img src={ProfilePic} alt="Vijay Jethanandani" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}
